import React from 'react';

import { SearchResultsType } from '@atom/types/search';

import InventoryResultRow from './InventoryResultRow';
import UserResultRow from './UserResultRow';
import WorkResultRow from './WorkResultRow';

import './searchPortal.css';

interface Props {
  query: string;
  results: SearchResultsType;
}

const AllResults = ({ query, results }: Props) => {
  return (
    <>
      {results?.assets?.map(asset => (
        <InventoryResultRow query={query} asset={asset} />
      ))}
      {results?.workOrders?.map(work => (
        <WorkResultRow query={query} work={work} />
      ))}
      {results?.users?.map(user => (
        <UserResultRow query={query} user={user} />
      ))}
    </>
  );
};

export default AllResults;
